export const LocalStorage = {
  language: "LANGUAGE",
  AUTH_TOKEN: "AUTH_TOKEN",
};
